import React from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../inputs/textInput.js';
import { logout } from '../../../businessLogic/authorizator';
import {
  updateShowChangeEmailModal,
  updateShowChangePasswordModal,
  updateShowUserProfileModal,
  showWAInviteSelfProvison,
  showMyRolesModal,
  updateShowQuickViewModal,
} from '../../../actions/modal';
import { getMyRoles } from '../../../actions/user';
import { clearCacheAsync } from '../../../actions/navigationBar.js';
import Avatar from 'react-avatar';
import { getUserAvatarText } from 'businessLogic/userAvatar';
import { redirectToInternalLink } from '../../../businessLogic/redirector';

export default function UserMenuDropdown(props) {
  const dispatch = useDispatch();
  const openInviteSelfProvision = () => {
    dispatch(showWAInviteSelfProvison(true));
  };

  const clearCache = () => {
    dispatch(clearCacheAsync());
  };
  const openPortalSettings = () => {
    dispatch(updateShowQuickViewModal(false));
    redirectToInternalLink('/portal-settings/view-all');
  };

  const logoutClick = () => {
    //on logout we remove the user wanted page
    window.sessionStorage.removeItem('userWantedPage');
    logout(dispatch);
  };

  const changePassword = () => {
    dispatch(updateShowChangePasswordModal(true));
  };

  const changeEmail = () => {
    dispatch(updateShowChangeEmailModal(true));
  };

  const showMyRole = () => {
    let cb = () => {
      dispatch(showMyRolesModal(true));
    };
    dispatch(getMyRoles(cb));
  };
  const goToProfile = () => {
    dispatch(updateShowUserProfileModal(true));
  };
  // Profile menu
  let avatarText = getUserAvatarText(props.user);
  // Need a wrapper for avatar img, otherwise the dropdown does not close when click
  let userMenuOptionTrigger = (
    <div
      className="inline-flex fl"
      style={{
        width: `${props.userAvatarSize}px`,
        height: `${props.userAvatarSize}px`,
      }}
    >
      <Avatar
        size={props.userAvatarSize}
        round={true}
        src={props.user.userImageUrl}
        color={props.user.isEmailOnlyUser ? window.styleVariable.primaryHoverColour : ''}
        name={avatarText}
        className={props.userAvatarClass ? props.userAvatarClass + ' user-avatar' : 'user-avatar'}
        textSizeRatio={props.userAvatarTextRatio}
      />
      <div
        style={{
          position: 'absolute',
          width: `${props.userAvatarSize}px`,
          height: `${props.userAvatarSize}px`,
        }}
      />
    </div>
  );

  // TODO - Need to check if isExclusivelyVcm is in use
  const showMultipleAdminMenu = !props.user.isExclusivelyVcm && props.user.isAdmin && !props.user.isSystemAdmin; //if they are admin, they can see adminstration menu as a dropwdown menu
  const showSystemAdminMenu = !props.user.isExclusivelyVcm && props.user.isAdmin && props.user.isSystemAdmin; //if they are system admin, they can see system-admin menu as a dropwdown menu
  const showSingleAdminMenu = !props.user.isExclusivelyVcm && !props.user.isAdmin; //if they are not admin, they can see adminstration menu as a link

  let userMenuOptions = [
    {
      text: APP.LANGUAGE.Menu.MyProfile,
      className: props.itemClass,
      onClick: () => goToProfile(),
    },
    {
      text: APP.LANGUAGE.Menu.MyRoles,
      className: 'menu-items-left-aligned no-sub-menu',
      onClick: () => showMyRole(),
    },
    {
      text: APP.LANGUAGE.Menu.ChangePassword,
      className: props.itemClass,
      onClick: () => changePassword(dispatch),
    },
    {
      text: APP.LANGUAGE.Menu.ChangeEmail,
      className: props.itemClass,
      onClick: () => changeEmail(dispatch),
    },
    {
      text: APP.LANGUAGE.HelpMenu.Administration,
      className: props.subMenuItemParentClass,
      subMenuClass: props.subMenuClass,
      show: showMultipleAdminMenu,
      subMenuOption: [
        {
          text: APP.LANGUAGE.AdminMenu.WASelfProvision,
          onClick: () => openInviteSelfProvision(),
        },
        {
          text: APP.LANGUAGE.AdminMenu.ClearCache,
          onClick: () => clearCache(),
        },
        {
          text: APP.LANGUAGE.AdminMenu.PortalSettings,
          onClick: () => openPortalSettings(),
        },
      ],
    },
    {
      text: APP.LANGUAGE.HelpMenu.Administration,
      className: props.subMenuItemParentClass,
      subMenuClass: props.subMenuClass,
      show: showSystemAdminMenu,
      subMenuOption: [
        {
          text: APP.LANGUAGE.AdminMenu.WASelfProvision,
          onClick: () => openInviteSelfProvision(),
        },
      ],
    },
    {
      text: APP.LANGUAGE.Menu.Logout,
      className: props.itemClass,
      onClick: () => logoutClick(),
    },
  ];

  return (
    <Txt
      semanticui
      dropdown
      MenuClassName="menu-bar-dropdown"
      trigger={userMenuOptionTrigger}
      normalSemanticUI={props.normalSemanticUI}
      className={props.userMenuClassName}
      id={props.id}
      options={userMenuOptions}
      childOnClickfunc={props.childOnClickfunc}
    />
  );
}
